import * as React from 'react';
import { config } from '../../config';
import styled from '@emotion/styled';
import { Link } from '../Link';
import { clearFilterParams } from '../../actions/searchActions';

const StyledWrapper = styled.div`
    padding-right: 10px;
`;

const StyledLink = styled(Link)`
    display: inline-block;
    max-width: 195px;
    height: 42px;
`;

const StyledImg = styled.img`
    height: 42px;
    display: block;
    max-width: 100%;
`;

interface IProps {
    clearFilterParams: typeof clearFilterParams;
    portalId: string;
    forceReload?: boolean;
    isMobile?: boolean;
}

export class Logo extends React.Component<IProps, any> {
    clearFilterParams = () => {
        this.props.clearFilterParams(false);
    };

    render() {
        const logoImage = this.props.isMobile ? 'logo_mobile.svg' : 'logo.svg';
        return (
            <StyledWrapper>
                <StyledLink
                    href="/"
                    onClick={this.clearFilterParams}
                    forceReload={this.props.forceReload}
                >
                    <StyledImg
                        src={`${config.images}/${this.props.portalId}/${logoImage}`}
                        alt="Dreamlines logo"
                        title="Dreamlines"
                    />
                </StyledLink>
            </StyledWrapper>
        );
    }
}
